import { render, staticRenderFns } from "./IAChat.vue?vue&type=template&id=033d7b0a"
import script from "./IAChat.vue?vue&type=script&lang=js"
export * from "./IAChat.vue?vue&type=script&lang=js"
import style0 from "./IAChat.vue?vue&type=style&index=0&id=033d7b0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports